/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-02-10",
    versionChannel: "nightly",
    buildDate: "2024-02-10T00:15:49.584Z",
    commitHash: "5c6930d72eb290eb720b0c44b84d109a78405eb9",
};
